import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

//引入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios;

//md5加密
import Md5 from "js-md5"
Vue.prototype.$md5 = Md5
/** 引入折线图图表，图表后缀都为 Chart  */
import * as echarts from 'echarts'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
/*import * as echarts from 'echarts/core'
 import { LineChart,BarChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent
} from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'
 */
// 注册必须的组件
/* echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LineChart,
  BarChart
]) */
Vue.prototype.$echarts = echarts

Vue.prototype.$formatDate = function(dateString, format) {
	let date1 = new Date(dateString)
	/* if(dateString.indexOf('+08:00') > 0){
		const isoDate = date1.toISOString().substring(0, 19);
		// 将ISO字符串转换回Date对象
		date1 = new Date(isoDate);
	} */
	const date = date1
	const year = date.getFullYear()
	const month = (date.getMonth() + 1).toString().padStart(2, '0')
	const day = date.getDate().toString().padStart(2, '0')
	if (format === 'yyyy-MM-dd') {
		return `${year}-${month}-${day}`
	} else if (format === 'yyyy-MM-dd HH:mm') {
		const hours = date.getHours().toString().padStart(2, '0')
		const minutes = date.getMinutes().toString().padStart(2, '0')
		// const seconds = date.getSeconds().toString().padStart(2, '0')
		return `${year}-${month}-${day} ${hours}:${minutes}`
	} else if (format === 'yyyy-MM-dd HH') {
		const hours = date.getHours().toString().padStart(2, '0')
		return `${year}-${month}-${day} ${hours}`
	} else if (format === 'HH:mm') {
		const hours = date.getHours().toString().padStart(2, '0')
		const minutes = date.getMinutes().toString().padStart(2, '0')
		// const seconds = date.getSeconds().toString().padStart(2, '0')
		return `${hours}:${minutes}`
	}else if (format === 'yyyy-MM-dd HH:mm:ss') {
		const hours = date.getHours().toString().padStart(2, '0')
		const minutes = date.getMinutes().toString().padStart(2, '0')
		const seconds = date.getSeconds().toString().padStart(2, '0')
		// const seconds = date.getSeconds().toString().padStart(2, '0')
		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
	}else if (format === 'HH:mm:ss') {
		const hours = date.getHours().toString().padStart(2, '0')
		const minutes = date.getMinutes().toString().padStart(2, '0')
		const seconds = date.getSeconds().toString().padStart(2, '0')
		return `${hours}:${minutes}:${seconds}`
	}else if(format === 'yyyyMMdd'){
		return `${year}${month}${day}`
	}else if(format === 'yyyy-MM'){
		return `${year}-${month}`
	}
}

//router设置路由拦截
router.beforeEach((to,from,next)=>{
	if(to.meta.requireLogin) {  // 检查登录
		let tk = sessionStorage.getItem("authToken")
		//console.log("tk = "+tk)
		if(tk === undefined || tk === null || tk == ''){
			next({
				path: 'noAuth401'
			})
		}else{
			next();
		}
	}else if(to.meta.requireAuth){  //检查权限
		
		next();
	}else{
		next();
	}
});

new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>',
	render: h => h(App),
}).$mount('#app')
